<template>
    <div id="accordionChoosePermissionSet">
        <!-- Accordion Item : Set Access Type -->
        <div class="card mb-0">
            <div class="card-header custom-card-header" id="userPermissionsOptions">
                <h5 class="mb-0">
                    <button class="btn btn-link custom-btn-link text-grey-darker collapsed" data-toggle="collapse" data-target="#collapseUserPermissionsOptions" aria-expanded="false" aria-controls="collapseUserPermissionsOptions">
                        <i class="fa fa-angle-right text-primary mr-3"></i>Choose how to set access
                    </button>
                </h5>
            </div>
            <div id="collapseUserPermissionsOptions" class="collapse" aria-labelledby="userPermissionsOptions" data-parent="#accordionChoosePermissionSet">
                <div class="card-body row mx-0 custom-card-body bg-white justify-content-center">
                    <!-- Option 1 -->
                    <div class="col-md-4 mb-4">
                        <label class="card radio-card p-3 h-100 cursor-pointer" :class="{ selected: selectedPresetAccessType === 'scratch' }">
                            <input type="radio" name="permissionOption" value="scratch" v-model="selectedPresetAccessType">
                            <h5 class="font-weight-bold mt-3">Start from scratch</h5>
                            <p class="text-muted">Create permissions specifically for this user.</p>
                        </label>
                    </div>

                    <!-- Option 2 -->
                    <div class="col-md-4 mb-4">
                        <label class="card radio-card p-3 h-100 cursor-pointer" :class="{ selected: selectedPresetAccessType === 'template' }">
                            <input type="radio" name="permissionOption" value="template" v-model="selectedPresetAccessType">
                            <h5 class="font-weight-bold mt-3">Start with a template</h5>
                            <p class="text-muted">Copy another user’s permissions or use common roles.</p>
                        </label>
                    </div>

                    <!-- Option 3 -->
                    <div class="col-md-4 mb-4">
                        <label class="card radio-card p-3 h-100 cursor-pointer" :class="{ selected: selectedPresetAccessType === 'system-admin' }">
                            <input type="radio" name="permissionOption" value="system-admin" v-model="selectedPresetAccessType">
                            <h5 class="font-weight-bold mt-3">Make System Admin</h5>
                            <p class="text-muted">System Admins can manage all users, tools, and settings.</p>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accordion Item : Choose Template -->
        <div class="card mb-0" v-if="selectedPresetAccessType === 'template'">
            <div class="card-header custom-card-header" id="chooseTemplate">
                <h5 class="mb-0">
                    <button class="btn btn-link custom-btn-link text-grey-darker collapsed" data-toggle="collapse" data-target="#collapseChooseTemplate" aria-expanded="false" aria-controls="collapseChooseTemplate">
                        <i class="fa fa-angle-right text-primary mr-3"></i>Choose template
                    </button>
                </h5>
            </div>
            <div id="collapseChooseTemplate" class="collapse" aria-labelledby="chooseTemplate" data-parent="#accordionChoosePermissionSet">
                <div class="card-body custom-card-body bg-white">
                    <div class="col-12">
                        <multiselect
                            v-if="selectedPresetAccessType === 'template'"
                            class="cursor-pointer appearance-none focus:outline-none rounded text-grey-darkest w-1/3 text-sm mb-4"
                            :options="templateOptions"
                            v-model="selectedPreset"
                            :show-labels="false"
                            group-values="optionValues"
                            group-label="optionTypes"
                            :group-select="false"
                            track-by="id"
                            label="name"
                            @input="selectedPresetChanged">
                        </multiselect>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accordion Item : Choose Permissions -->
        <div class="card mb-0" v-show="showChoosePermissionsTab">
            <div class="card-header custom-card-header" id="chooseUserPermissions">
                <h5 class="mb-0">
                    <button class="btn btn-link custom-btn-link text-grey-darker collapsed" data-toggle="collapse" data-target="#collapseChooseUserPermissions" aria-expanded="false" aria-controls="collapseChooseUserPermissions">
                        <i class="fa fa-angle-right text-primary mr-3"></i>Choose permissions
                    </button>
                </h5>
            </div>
            <div id="collapseChooseUserPermissions" class="collapse" aria-labelledby="chooseUserPermissions" data-parent="#accordionChoosePermissionSet">
                <div class="card-body custom-card-body bg-white">
                    <div class="col-12">
                        <choose-permissions
                            ref="ChoosePermissions"
                            :team="team">
                        </choose-permissions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChoosePermissions from "./choose-permissions.vue";
import Multiselect from "vue-multiselect";

export default {
    name: "choose-set-access",
    components: {Multiselect, ChoosePermissions},
    props: ['team'],
    data() {
        return {
            usersList: [],
            presetList: [],
            selectedPreset: null,
            selectedPresetAccessType: 'scratch'
        }
    },
    computed: {
        showChoosePermissionsTab() {
            if(this.selectedPresetAccessType === 'template' && this.selectedPreset === null) {
                return false;
            }
            return this.selectedPresetAccessType !== 'system-admin';
        },
        templateOptions() {
            return [
                {
                    "optionTypes": `Presets (${this.presetList.length})`,
                    "optionValues": this.presetList
                },
                {
                    "optionTypes": `Users (${this.usersList.length})`,
                    "optionValues": this.usersList
                }
            ];
        }
    },
    mounted() {
        this.getTeamAllPresets();
        this.getTeamAllUsers();
    },
    methods: {
        getTeamAllPresets() {
            let self = this;

            axios.get('/settings/' + this.team.id + '/permissions/roles/all/without-pagination').then(({data}) => {
                self.presetList = data.data;
            });
        },
        getTeamAllUsers() {
            let self = this;

            axios.get('/settings/' + this.team.id + '/permissions/users/all/without-pagination').then(({data}) => {
                self.usersList = data.data;
            });
        },
        resetAllData() {
            this.selectedPreset = null;
            this.selectedPresetAccessType = 'scratch';
            $('#collapseChooseUserPermissions').collapse('hide');
            this.$refs.ChoosePermissions.resetData();
        },
        selectedPresetChanged() {
            this.$refs.ChoosePermissions.resetData();
            this.$refs.ChoosePermissions.mapSavedPermissions(this.selectedPreset.permissions);
        },
        copyOldUserPermission(userId, teamId) {
            this.selectedPresetAccessType = 'template';
            this.selectedPreset = _.find(this.usersList, { 'id': userId, 'team_id': teamId });
            this.$nextTick(() => {
                $('#collapseChooseTemplate').collapse('show');
                this.selectedPresetChanged();
            });
        }
    }
}
</script>

<style scoped>
.card .custom-card-header {
    border-color: rgb(203, 214, 226);
    background-color: rgb(245, 248, 250);
    padding: .5rem .75rem;
    border-width: 1px 1px;
    border-bottom: none;
    border-radius: unset;
}
.card .custom-card-body {
    border-width: 1px 1px;
}
.custom-btn-link {
    text-decoration: none;
    box-shadow: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
}
.custom-btn-link:hover {
    text-decoration: none;
    color: #01B1AF;
}
.radio-card input[type="radio"] {
    display: none;
}
.radio-card.selected {
    border-color: #01b1AF;
    background-color: #daf8f8;
    box-shadow: 0 0 0 3px #01b1AF;
    transition: all .3s ease;
}
</style>
